<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">  

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" title="Volver" (click)="onBack()"><i class="fa fa-chevron-left"></i></button>
            <button type="submit" class="btn btn-outline-success" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        </div>

    </nav>

    <div class="animated fadeIn container-fluid">

        <h4>{{editTitle}} Ubicación</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <div class="card-body">

                        <div class="row">

                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpDescripcion">Descripción</label>
                                <input formControlName="Descripcion" name="Descripcion" title="" class="form-control"
                                       maxlength="100" [ngClass]="displayFieldCss('Descripcion')" id="inpDescripcion" type="text" value="">

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','required')">
                                    Descripcion es obligatorio
                                </div>

                                <div class="invalid-feedback" *ngIf="isFieldInvalid('Descripcion','descripcion_duplicated')">
                                    Descripción ya existe
                                </div>
                            </div>

                            <div class="form-group col-md-4">
                                <label class="col-form-label required-field" for="inpPuntoInspeccion">Punto de Inspección</label>

                                <ng-select loadingText="Cargando..."
                                           [items]="listPuntoInspeccion"
                                           placeholder="-- Seleccione un PIF --"
                                           [readonly]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                           [loading]="!listPuntoInspeccion || listPuntoInspeccion.length === 0"
                                           bindLabel="Descripcion"
                                           bindValue="Id"
                                           formControlName="IdPuntoInspeccion"
                                           notFoundText="PIF no encontrado"
                                           [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                           clearAllText="Eliminar selección">
                                </ng-select>

                                <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                    El Punto de Inspección es obligatorio
                                </div>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpHabilitadaImportacion">Habilitada Importación</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadaImportacion"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpHabilitadaExportacion">Habilitada Exportación</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="HabilitadaExportacion"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                        </div>

                        <div class="row">

                            <div class="form-group col-md-2">
                                <label class="col-form-label" for="inpPorDefecto">Por Defecto</label>
                                <p-toggleButton class="form-control-togglebutton" formControlName="PorDefecto"
                                                onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                offIcon="pi pi-times"></p-toggleButton>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</form>
